import { ReduxAction } from 'types/redux.types';
import actions from './actions';

export interface OrderSourceState {
  source: string | null;
}

const initialState: OrderSourceState = {
  source: null,
};

export default function reducer(
  state: OrderSourceState = initialState,
  action: ReduxAction
): OrderSourceState {
  switch (action.type) {
    case actions.SET_ORDER_SOURCE:
      return { ...state, source: action.payload ?? null };
    default:
      return state;
  }
}
